// import ToggleState from 'javascripts/modules/toggle-state';

class NavSlider {

	constructor(){
		this.component = document.querySelector(`[data-component="primary-nav"]`);

		if(this.component){

			this.triggerSlide   = this.component.querySelectorAll('[data-state="has-child"]');
			this.triggerBack    = this.component.querySelectorAll('[data-trigger-back]');
			this.currentElement = [];
			this.autoheight     = this.component.hasAttribute('data-autoheight') ? true : false;
			// this.component.style.minHeight = this.component.offsetHeight+'px';
			this._init();

		}
	}

	_init(){

		// Slide between subcategories (touch)
  	for (let element of this.triggerSlide) {
	    element.addEventListener('click', 
	    	(event) => this._slide(element, 'forward', event)
	    );
  	}

		// Nav back
  	for (let element of this.triggerBack) {
	    element.addEventListener('click', 
	    	(event) => this._slide(element, 'backward', event)
	    );
  	}
	}
		
	_slide(elem, direction, event){
		
		let level = +this.component.getAttribute('data-level');

		if(direction === 'backward') {

			let oldLevel = level;
			    level    = event.currentTarget.getAttribute('data-trigger-back');

			// Hide child elements after slide
			setTimeout(()=>{
				let last = this.currentElement.splice(level - oldLevel);
				for (let element of last) {
			    element.removeAttribute('data-childs');
		  	}
			}, 300);


		} else if (direction === 'forward') {

			// Display child elements
			const itemElement = event.currentTarget.parentNode;
			itemElement.setAttribute('data-childs', 'visible');

			// Store item to hide childs when the back button is pushed
			this.currentElement.push(itemElement);

			if(level < 3 ){
				level++;
			}
		}

		if(this.autoheight){

			// get next slide
			let slide = null;
			if(parseInt(level) === 1){
				slide = this.component.querySelector('[data-target="level'+level+'"]');
			}else{
				slide = this.component.querySelector('[data-childs="visible"] [data-target="level'+level+'"]');
			}
			
			// si la nouvelle slide est + grande, on adapte la hauteur tout de suite,
			// sinon on attend la fin de l'anim
			if(slide && this.component.offsetHeight < slide.offsetHeight){
				this.component.style.height = slide.offsetHeight+'px';
			}else if(slide){
				setTimeout(()=>{
					this.component.style.height = slide.offsetHeight+'px';
				}, 300);
			}
		}

		this.component.setAttribute('data-level', level);
		event.preventDefault();
		event.stopPropagation();
	}

}

export const navSlider = new NavSlider();